import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import logoColor from '../assets/Taha Wairua logo-colour.png'
import logoWhite from '../assets/Taha Wairua logo-white.png'
import './Header.css'

const MOBILE_BREAKPOINT = 640

function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isGetInvolvedOpen, setIsGetInvolvedOpen] = useState(false)
  const [isMobileGetInvolvedOpen, setIsMobileGetInvolvedOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > MOBILE_BREAKPOINT) {
        setIsMobileMenuOpen(false)
      }
      setIsGetInvolvedOpen(false)
      setIsMobileGetInvolvedOpen(false)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsGetInvolvedOpen(false)
      }
    }

    document.addEventListener('mousedown', handleOutsideClick)
    return () => document.removeEventListener('mousedown', handleOutsideClick)
  }, [])

  const closeAllMenus = () => {
    setIsMobileMenuOpen(false)
    setIsGetInvolvedOpen(false)
    setIsMobileGetInvolvedOpen(false)
  }

  return (
    <header className="header">
      <nav className="header-nav">
        <div className="header-left">
          <Link to="/about-us" className="nav-link">
            About Us
          </Link>
          <div className="dropdown" ref={dropdownRef}>
            <button
              type="button"
              className={`nav-link dropdown-toggle getInvolvedLink ${isGetInvolvedOpen ? ' is-open' : ''}`}
              onClick={() => setIsGetInvolvedOpen((isOpen) => !isOpen)}
              aria-expanded={isGetInvolvedOpen}
              aria-haspopup="true"
            >
              Get Involved
            </button>
            {isGetInvolvedOpen && (
              <div className="dropdown-menu">
                <Link
                  to="/for-principles"
                  className="dropdown-item"
                  onClick={closeAllMenus}
                >
                  For Principals
                </Link>
                <Link
                  to="/for-parents"
                  className="dropdown-item"
                  onClick={closeAllMenus}
                >
                  For Parents
                </Link>
                <Link
                  to="/for-pastors"
                  className="dropdown-item"
                  onClick={closeAllMenus}
                >
                  For Pastors
                </Link>
                <Link
                  to="/for-youth"
                  className="dropdown-item"
                  onClick={closeAllMenus}
                >
                  For Youth
                </Link>
              </div>
            )}
          </div>
          <Link to="/events" className="nav-link">
            Events
          </Link>
        </div>
        <div className="header-center">
          <Link to="/" className="logo-link" onClick={closeAllMenus}>
            <span className="logo-stack" aria-label="Taha Wairua logo">
              <img
                src={logoColor}
                alt="Taha Wairua logo"
                className="logo logo-color"
              />
              <img
                src={logoWhite}
                alt=""
                aria-hidden="true"
                className="logo logo-white"
              />
            </span>
          </Link>
        </div>
        <div className="header-right">
          <Link to="/contact" className="nav-link">
            Contact
          </Link>
          <Link to="/resources" className="nav-link">
            Resources
          </Link>
        </div>
        <button
          type="button"
          className="hamburger-btn"
          aria-label="Open navigation menu"
          aria-expanded={isMobileMenuOpen}
          onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <Link to="/about-us" className="nav-link" onClick={closeAllMenus}>
            About Us
          </Link>
          <button
            type="button"
            className={`nav-link mobile-dropdown-toggle${isMobileGetInvolvedOpen ? ' is-open' : ''}`}
            onClick={() => setIsMobileGetInvolvedOpen((isOpen) => !isOpen)}
            aria-expanded={isMobileGetInvolvedOpen}
          >
            Get Involved
          </button>
          {isMobileGetInvolvedOpen && (
            <div className="mobile-submenu">
              <Link
                to="/for-principles"
                className="nav-link"
                onClick={closeAllMenus}
              >
                For Principals
              </Link>
              <Link
                to="/for-parents"
                className="nav-link"
                onClick={closeAllMenus}
              >
                For Parents
              </Link>
              <Link
                to="/for-pastors"
                className="nav-link"
                onClick={closeAllMenus}
              >
                For Pastors
              </Link>
              <Link to="/for-youth" className="nav-link" onClick={closeAllMenus}>
                For Youth
              </Link>
            </div>
          )}
          <Link to="/events" className="nav-link" onClick={closeAllMenus}>
            Events
          </Link>
          <Link to="/contact" className="nav-link" onClick={closeAllMenus}>
            Contact
          </Link>
          <Link to="/resources" className="nav-link" onClick={closeAllMenus}>
            Resources
          </Link>
        </div>
      )}
    </header>
  )
}

export default Header
